import dayjs, { Dayjs } from "dayjs";
import Locale from "../../../core/locale/locale";
import { Event_Type } from "../../../constant/constant";
import { MediaHubTabs } from "../../media-hub/utils/utils";
import { Birthday, IEvent, WorkAnniversary } from "../../../domains/models/event";
import { AuditInfo } from "../../../domains/models/common/audit-info";

export const formatDate = (date: string | Date | Dayjs) => {
    if (dayjs.isDayjs(date)) {
        return date.format(Locale.dateFormat)
    } else {
        return dayjs(date).format(Locale.dateFormat)
    }
};
export const formatTime = (time: string) => (dayjs(time).format('HH:mm:ss'))


export function getMonthFromDate(date: Dayjs) {
    const startDate = date.startOf('month').startOf('day');
    const endDate = date.endOf('month').endOf('day');
    return {startDate, endDate}
}

export function getMonthFromRange(start: Date | Dayjs, end: Date | Dayjs) {

    const startDay = dayjs(start);
    const endDay = dayjs(end);

    const midTime = startDay.valueOf() + (endDay.valueOf() - startDay.valueOf()) / 2;
    const midDate = dayjs(midTime);

    const startDate = midDate.startOf("month").startOf("day");
    const endDate = midDate.endOf("month").endOf("day");


    return {startDate, endDate};
}



export function getPreviousMonth(date: Dayjs): Dayjs {
    return dayjs(date).subtract(1, "month").startOf("month").startOf('day');
}

export function getNextMonth(date: Dayjs): Dayjs {
    return dayjs(date).add(1, "month").startOf("month").startOf('day');
}

export function getTabByEventType(type: any) {
    return MediaHubTabs.find(item => item.label === Event_Type[type as keyof typeof Event_Type])?.path ?? 'others';
}
